import equitationPic from "../assets/icons/stretching-cheval-equitation.jpg"
import threeDPrintingPic from "../assets/icons/5baa597861_50153774_fotolia-stockphoto-graf.jpg"
import codingPic from "../assets/icons/top-5-programming-languages-hero1579801696278282.jpg"
import bakingPic from "../assets/icons/921785662PastryCook.webp"
import dronePic from "../assets/icons/ou-peut-on-faire-voler-un-drone-en-france.jpg"

export default [
  {
    name: "Initiation à l'équitation",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh",
    categories: ["Sport"],
    type: "test",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 2, max: 4 },
    price: 23,
    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    pics: [equitationPic],
    sessions: [
      {
        date: "2021/11/30",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2021/03/21",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },
  {
    name: "Devenez patissier l'espace d'une apres-midi",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    categories: ["Cuisine"],

    type: "test1",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 1, max: 5 },
    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 12,
    pics: [
      bakingPic,
      "../assets/icons/civ Jan 22.png",
      "../assets/icons/Niche-Cake-Loaves-of-bread-Business.jpg",
    ],
    sessions: [
      {
        date: "2021/11/30",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2021/12/21",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: true,
  },
  {
    name: "Initiation au pilotage de drone",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh3",
    categories: ["Tech"],

    type: "test",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 2, max: 12 },

    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 23,
    pics: [dronePic],
    sessions: [
      {
        date: "2021/12/02",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2021/12/11",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },
  {
    name: "Créez votre propre application de chat sur Android !",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh3",
    categories: ["Tech"],

    type: "test",
    sessionsNumber: 1,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 1, max: 2 },

    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 100,
    pics: [codingPic],
    sessions: [
      {
        date: "2021/12/04",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2021/12/09",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },

  {
    name: "Venez créez votre premiere impression 3D !",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh3",
    categories: ["Tech"],

    type: "test",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 2, max: 5 },

    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 50,
    pics: [threeDPrintingPic],
    sessions: [
      {
        date: "2021/12/11",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2021/12/13",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },
  {
    name: "Initiation à l'équitation",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh",
    categories: ["Sport"],
    type: "test",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 2, max: 4 },
    price: 23,
    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    pics: [equitationPic],
    sessions: [
      {
        date: "2021/12/15",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2021/12/16",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },
  {
    name: "Devenez patissier l'espace d'une apres-midi",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    categories: ["Cuisine"],

    type: "test1",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 1, max: 5 },
    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 12,
    pics: [
      bakingPic,
      "../assets/icons/civ Jan 22.png",
      "../assets/icons/Niche-Cake-Loaves-of-bread-Business.jpg",
    ],
    sessions: [
      {
        date: "2021/12/21",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2021/12/24",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: true,
  },
  {
    name: "Initiation au pilotage de drone",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh3",
    categories: ["Tech"],

    type: "test",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 2, max: 12 },

    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 23,
    pics: [dronePic],
    sessions: [
      {
        date: "2021/12/25",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2021/12/26",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },
  {
    name: "Créez votre propre application de chat sur Android !",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh3",
    categories: ["Tech"],

    type: "test",
    sessionsNumber: 1,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 1, max: 2 },

    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 100,
    pics: [codingPic],
    sessions: [
      {
        date: "2022/01/01",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2022/01/21",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },

  {
    name: "Venez créez votre premiere impression 3D !",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh3",
    categories: ["Tech"],

    type: "test",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 2, max: 5 },

    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 50,
    pics: [threeDPrintingPic],
    sessions: [
      {
        date: "2022/01/02",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2022/01/12",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },
  {
    name: "Initiation à l'équitation",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh",
    categories: ["Sport"],
    type: "test",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 2, max: 4 },
    price: 23,
    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    pics: [equitationPic],
    sessions: [
      {
        date: "2022/01/09",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2022/01/14",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },
  {
    name: "Devenez patissier l'espace d'une apres-midi",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    categories: ["Cuisine"],

    type: "test1",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 1, max: 5 },
    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 12,
    pics: [
      bakingPic,
      "../assets/icons/civ Jan 22.png",
      "../assets/icons/Niche-Cake-Loaves-of-bread-Business.jpg",
    ],
    sessions: [
      {
        date: "2022/02/01",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2022/02/02",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: true,
  },
  {
    name: "Initiation au pilotage de drone",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh3",
    categories: ["Tech"],

    type: "test",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 2, max: 12 },

    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 23,
    pics: [dronePic],
    sessions: [
      {
        date: "2022/02/03",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2022/02/04",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },
  {
    name: "Créez votre propre application de chat sur Android !",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh3",
    categories: ["Tech"],

    type: "test",
    sessionsNumber: 1,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 1, max: 2 },

    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 100,
    pics: [codingPic],
    sessions: [
      {
        date: "2022/02/04",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2022/02/11",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },

  {
    name: "Venez créez votre premiere impression 3D !",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh3",
    categories: ["Tech"],

    type: "test",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 2, max: 5 },

    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 50,
    pics: [threeDPrintingPic],
    sessions: [
      {
        date: "2022/02/12",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2022/02/13",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },
  {
    name: "Initiation à l'équitation",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh",
    categories: ["Sport"],
    type: "test",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 2, max: 4 },
    price: 23,
    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    pics: [equitationPic],
    sessions: [
      {
        date: "2022/02/15",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2022/02/21",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },
  {
    name: "Devenez patissier l'espace d'une apres-midi",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    categories: ["Cuisine"],

    type: "test1",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 1, max: 5 },
    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 12,
    pics: [
      bakingPic,
      "../assets/icons/civ Jan 22.png",
      "../assets/icons/Niche-Cake-Loaves-of-bread-Business.jpg",
    ],
    sessions: [
      {
        date: "2022/02/21",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2022/02/30",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Rambouillet",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: true,
  },
  {
    name: "Initiation au pilotage de drone",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh3",
    categories: ["Tech"],

    type: "test",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 2, max: 12 },

    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 23,
    pics: [dronePic],
    sessions: [
      {
        date: "2022/03/01",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2022/03/04",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },
  {
    name: "Créez votre propre application de chat sur Android !",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh3",
    categories: ["Tech"],

    type: "test",
    sessionsNumber: 1,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 1, max: 2 },

    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 100,
    pics: [codingPic],
    sessions: [
      {
        date: "2022/03/05",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2022/03/07",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },

  {
    name: "Venez créez votre premiere impression 3D !",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    caterory: "meh3",
    categories: ["Tech"],

    type: "test",
    sessionsNumber: 2,
    coordinates: [],
    typeformLink: "",
    participantsQuotasInfo: { min: 2, max: 5 },

    hostDescription: {
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    price: 50,
    pics: [threeDPrintingPic],
    sessions: [
      {
        date: "2022/03/10",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
      {
        date: "2022/03/12",
        duration: 180,
        objectives: [
          {
            verb: "Lorem",
            text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
          },
        ],
        location: "Paris",
        toBring: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
        provided: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
          "ever since the 1500s, when an unknown printer took a galley",
        ],
        offered: ["Lorem ipsum"],
        advice: [
          "Lorem Ipsum is simply dummy",
          "printing and typesetting industry. Lorem",
        ],
      },
    ],
    isTest: false,
  },
]
